/**
 * Agent Order Configuration
 * This file defines the canonical order for agents as per business requirements
 * Updated with final list of 20 agents
 */

export const AGENT_ORDER = [
  'site-crawler',                    // 1) Site Crawler Agent
  'page-semantic-intent',            // 2) Page Semantic Agent
  'adjacent-topics',                 // 3) Adjacent topics Explorer
  'customer-intent',                 // 4) Customer Intent Agent
  'page-chatbot',                    // 5) Pager Chatbot Agent
  'voice-assistant',                 // 6) Voice Assistant Agent
  'topic-research',                  // 7) Topic Research Agent
  'web-analyst',                     // 8) Analytics Insights Agent (aka Web Analyst)
  'competitive-analysis',            // 9) Competitors Analyst Agent
  'counter-narrative',               // 10) Counter Narrative Builder
  'narrative-presentation',          // 11) Page Narrator
  'hands-off-navigation',            // 12) Hands off navigator
  'product-comparison',              // 13) Product Comparison Agent
  'question-suggestion',             // 14) Question Suggester
  'customer-surveys',                // 15) Know Your Customer Surveys Agent
  'replay-analyst',                  // 16) Replay analyst: friction finder
  'behavior-analyst',                // 17) Behavior Analyst
  'customer-segmentation',           // 18) Customer Segmentation Agent
  'segment-research',                // 19) Segment Research Agent
  'site-sector-analyzer',            // 20) Site Sector Analyzer
  'growth-analyst',                  // 21) Growth Analyst
  'auto-evaluator',                  // 22) Auto-evaluator Agent
  'insights-hub',                    // 23) Insights Hub Agent
  'intent-based-recommender',        // 24) Intent-based Recommender
  'keyword-extractor',               // 25) Keyword Extractor Agent
  'page-role',                       // 26) Page Role Agent
  'session-summarizer',              // 27) Session Summarizer Agent
  'style-suggestion',                // 28) Style Suggestion Agent
  'chatbot-intent-classifier',       // 29) Chatbot Intent Classifier
  'chatbot-quality-scorer',          // 30) Chatbot Quality Scorer
  'chatbot-content-gap-detector',    // 31) Chatbot Content Gap Detector
  'chatbot-conversation-flow-analyzer', // 32) Chatbot Conversation Flow Analyzer
  'chatbot-analytics-agent'          // 33) Chatbot Analytics Orchestrator
];

export const MISSING_AGENTS = [
  // All agents now have images/videos, none are missing
];

// Map old IDs to new IDs for consistency
export const AGENT_ID_MAPPING: Record<string, string> = {
  'site-crawler-agent': 'site-crawler',
  'page-semantic-intent-agent': 'page-semantic-intent',
  'customer-intent-agent': 'customer-intent',
  'page-chatbot-agent': 'page-chatbot',
  'voice-assistant-agent': 'voice-assistant',
  'voice-chatbot': 'voice-assistant', // Remove duplicate voice agent
  'voice-chatbot-agent': 'voice-assistant', // Remove duplicate voice agent
  'analytics-insight-agent': 'web-analyst',
  'topic-research-agent': 'topic-research',
  'competitors-analyst': 'competitive-analysis',
  'question-suggestion-agent': 'question-suggestion',
  'suggestions-with-answer': 'question-suggestion', // Merge similar agents
  'know-your-customer-surveys': 'customer-surveys',
  'site-sector-classifier': 'site-sector-analyzer', // Map to correct ID
  'sector-assigner': 'site-sector-analyzer', // Map sector assigner to analyzer
  'customer-segmentation-agent': 'customer-segmentation',
  'segment-research-agent': 'segment-research',
  'page-role-agent': 'page-role',
  'session-summarizer-agent': 'session-summarizer',
  'insights-hub-agent': 'insights-hub',
  'keyword-extractor-agent': 'keyword-extractor',
  'auto-evaluator-agent': 'auto-evaluator',
  'style-suggestion-agent': 'style-suggestion',
  'intent-based-recommender-agent': 'intent-based-recommender'
};